/** autogenerated by 'npm script:postversion', do not change!**/
export const VERSION = "1.9.9";
